
//This function evaluates whether an event sent by a web worker is the event type we want.
export function isEventType(event: MessageEvent, eventType: string) {
    return event.data.hasOwnProperty("dataType") && event.origin === window.location.origin && event.data.dataType === eventType;
}